export default {
  formattedDateString(dateString, type) {
    if (type == 'date' && dateString.indexOf('T') > -1) {
      return dateString.substr(0, dateString.indexOf('T'));
    } else {
      return dateString
    }
  }
}